import React from 'react';
import './styles-heroes.full-bleed.css';
import '../TwoColumnTextImage/styles.css';
import '../TwoColumnTextImage/styles-heroes.hero.css';
import '../TwoColumnTextImage/styles-heroes.default.css';
import '../SharedUtils/c-buttons.css';
import '../FullWidthRichText/subtitle.css';
import '../FullWidthRichText/typography.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import { Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { useInvertedColor } from '../SharedUtils/hooks';

import {
  renderTextFields,
  getDisableMarginBottomCss,
  getColumnRatioClass,
} from '../TwoColumnTextImage';

const TwoColumnTextImageFullBleed = ({ fields, rendering, sitecoreContext }) => {
  const componentId = `c-${rendering.uid}`;

  const widgetStyles = {};
  const widgetClasses = ['o-widget', 'c-hero', 'c-hero--full-bleed'];

  const isInverted = useInvertedColor(fields);

  if (fields.ImageVerticalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageVerticalAlignment?.fields?.value?.value);

  const textAlignCss = fields.TextAlignRight?.value ? 'is-aligned-right' : '';
  if (textAlignCss) widgetClasses.push(textAlignCss);

  const disableMarginBottomCss = getDisableMarginBottomCss(fields);
  if (disableMarginBottomCss) widgetClasses.push(disableMarginBottomCss);

  if (isInverted) widgetClasses.push('is-inverted');

  return (
    <div
      id={componentId}
      className={widgetClasses.join(' ')}
      style={widgetStyles}
      {...RenderingStyling(rendering.componentName)}
      tabIndex="-1"
    >
      <div className={`c-container container-row ${getColumnRatioClass(fields.ColumnsSize)}`}>
        <div className="c-hero__bg-image c-hero__column--secondary">
          <div className="relative">
            <figure tabIndex="0" className="c-hero__image">
              <Image field={fields.Image} width="" height="" />
            </figure>
          </div>
        </div>
        <div className="c-hero__column--primary column">
          <div className="c-hero__content u-small-text-center">
            {renderTextFields({ fields: fields })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(TwoColumnTextImageFullBleed);
